"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const itLocaleData = require("i18next-icu/locale-data/it");
exports.default = itLocaleData;
//# sourceMappingURL=it.js.map